import { Box, styled } from '@mui/system';
import { commonColors } from 'applicaiton/theme';

export const ModalStyled = styled(Box)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  outline: none;
  display: flex;
  flex-direction: column;
  width: 500px;
  padding: 32px;
  gap: 32px;
  border-radius: 8px;
  background: ${commonColors.success4};
  box-shadow: 0 10px 45px 0 rgba(14, 40, 83, 0.07);
  .content-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }
  p {
    color: ${commonColors.grey700};
    font-size: 18px;
    font-weight: 400;
    line-height: 25px;
  }
  .actions-wrapper {
    display: flex;
    justify-content: center;
    > button {
      width: 120px;
    }
  }
`;
